const c = {
  name: "Technology",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,16c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C24,17.8,22.2,16,20,16z M18,20c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C18.9,22,18,21.1,18,20z"/>
		<path class="st0" d="M22.2,4.7c0.5,0.6,0.9,1.3,1.3,2.1C24.3,6.4,25,6,25.7,5.7c1.8-0.8,3.5-1.3,4.9-1.4c1.5-0.1,2.9,0.2,3.9,1.2
			c1,1,1.3,2.4,1.2,3.9c-0.1,1.5-0.6,3.2-1.4,4.9c-0.3,0.7-0.7,1.5-1.1,2.2c0.8,0.4,1.5,0.9,2.1,1.3c1.6,1.1,2.9,2.3,3.7,3.6
			c0.8,1.2,1.3,2.6,0.9,3.9c-0.4,1.3-1.4,2.3-2.7,3c-1.3,0.7-3,1.1-5,1.2c-0.8,0.1-1.6,0.1-2.5,0.1c0,0.9,0,1.7-0.1,2.5
			c-0.2,1.9-0.6,3.7-1.2,5c-0.7,1.3-1.6,2.4-3,2.7c-1.3,0.4-2.7-0.1-3.9-0.9c-1.2-0.8-2.4-2.1-3.6-3.7c-0.5-0.6-0.9-1.3-1.3-2.1
			c-0.8,0.4-1.5,0.8-2.2,1.1c-1.8,0.8-3.5,1.3-4.9,1.4c-1.5,0.1-2.9-0.2-3.9-1.2c-1-1-1.3-2.4-1.2-3.9c0.1-1.5,0.6-3.2,1.4-4.9
			C6,25,6.4,24.3,6.8,23.5c-0.8-0.4-1.5-0.9-2.1-1.3C3.1,21,1.8,19.8,1,18.6c-0.8-1.2-1.3-2.6-0.9-3.9c0.4-1.3,1.4-2.3,2.7-3
			c1.3-0.7,3-1.1,5-1.2c0.8-0.1,1.6-0.1,2.5-0.1c0-0.9,0-1.7,0.1-2.5c0.2-1.9,0.6-3.7,1.2-5c0.7-1.3,1.6-2.4,3-2.7
			C16-0.2,17.4,0.2,18.6,1C19.8,1.8,21.1,3.1,22.2,4.7z M12.4,10.4c1.7,0.1,3.4,0.3,5.2,0.6c1.4-1.2,2.8-2.2,4.2-3.1
			c-0.4-0.7-0.8-1.4-1.3-2c-1.1-1.5-2.1-2.6-3.1-3.2c-1-0.6-1.7-0.8-2.3-0.6c-0.6,0.2-1.2,0.7-1.7,1.7c-0.5,1-0.9,2.5-1,4.3
			C12.4,8.8,12.4,9.6,12.4,10.4z M20.1,11.5c0.7,0.2,1.3,0.3,2,0.5c0.7,0.2,1.3,0.4,2,0.6c-0.4-1-0.9-2-1.3-3
			C21.9,10.2,21,10.8,20.1,11.5z M12.4,12.4c0.1,1,0.2,2.1,0.3,3.2c0.5-0.5,0.9-1,1.4-1.5c0.5-0.5,1-1,1.5-1.4
			C14.5,12.6,13.4,12.5,12.4,12.4z M15.6,15.6c-0.9,0.9-1.7,1.7-2.4,2.6c0.2,1.1,0.5,2.3,0.8,3.5c0.3,1.2,0.7,2.3,1,3.4
			c1.1,0.4,2.2,0.7,3.4,1c1.2,0.3,2.3,0.6,3.5,0.8c0.9-0.8,1.7-1.6,2.6-2.4c0.9-0.9,1.7-1.7,2.4-2.6c-0.2-1.1-0.5-2.3-0.8-3.4
			c-0.3-1.2-0.7-2.3-1-3.4c-1.1-0.4-2.2-0.7-3.4-1c-1.2-0.3-2.3-0.6-3.4-0.8C17.3,13.9,16.4,14.7,15.6,15.6z M10.4,12.4
			c-0.8,0-1.6,0-2.4,0.1c-1.8,0.2-3.3,0.5-4.3,1c-1,0.5-1.5,1.1-1.7,1.7c-0.2,0.6,0,1.4,0.6,2.3c0.6,1,1.7,2,3.2,3.1
			c0.6,0.4,1.3,0.9,2,1.3c0.9-1.4,2-2.8,3.1-4.2C10.7,15.8,10.5,14,10.4,12.4z M11.5,20.1c-0.7,0.9-1.3,1.8-1.9,2.6
			c0.9,0.5,1.9,0.9,3,1.3c-0.2-0.6-0.4-1.3-0.6-2C11.8,21.5,11.7,20.8,11.5,20.1z M7.5,26.6c-0.8,1.7-1.2,3.1-1.2,4.2
			c-0.1,1.2,0.2,1.9,0.6,2.3c0.4,0.4,1.2,0.7,2.3,0.6c1.1-0.1,2.6-0.5,4.2-1.2c0.7-0.3,1.4-0.7,2.1-1.1c-0.7-1.5-1.5-3.1-2.1-4.8
			c-1.7-0.6-3.4-1.3-4.8-2.1C8.2,25.2,7.8,25.9,7.5,26.6z M19.4,34.1c1.1,1.5,2.1,2.6,3.1,3.2c1,0.6,1.7,0.8,2.3,0.6
			c0.6-0.2,1.2-0.7,1.7-1.7c0.5-1,0.9-2.5,1-4.3c0.1-0.7,0.1-1.5,0.1-2.4c-1.7-0.1-3.4-0.3-5.2-0.6c-1.4,1.2-2.8,2.2-4.2,3.2
			C18.6,32.8,19,33.5,19.4,34.1z M17.2,30.4c0.9-0.6,1.7-1.2,2.6-1.9c-0.7-0.2-1.3-0.3-2-0.5c-0.7-0.2-1.3-0.4-2-0.6
			C16.3,28.4,16.8,29.4,17.2,30.4z M27.6,27.6c-0.1-1-0.2-2.1-0.3-3.2c-0.5,0.5-0.9,1-1.4,1.5c-0.5,0.5-1,1-1.5,1.4
			C25.5,27.4,26.6,27.5,27.6,27.6z M29.6,27.6c0.8,0,1.6,0,2.4-0.1c1.8-0.2,3.3-0.5,4.3-1c1-0.5,1.5-1.1,1.7-1.7
			c0.2-0.6,0-1.4-0.6-2.3c-0.6-1-1.7-2-3.2-3.1c-0.6-0.4-1.3-0.9-2-1.3c-0.9,1.4-2,2.8-3.2,4.2C29.3,24.2,29.5,26,29.6,27.6z
			 M26.6,13.4c1.7,0.6,3.4,1.3,4.8,2.1c0.4-0.7,0.8-1.4,1.1-2.1c0.8-1.7,1.2-3.1,1.2-4.2c0.1-1.2-0.2-1.9-0.6-2.3
			c-0.4-0.4-1.2-0.7-2.3-0.6c-1.1,0.1-2.6,0.5-4.2,1.2c-0.7,0.3-1.4,0.7-2.1,1.1C25.2,10.1,25.9,11.7,26.6,13.4z M28.5,19.9
			c0.7-0.9,1.3-1.8,1.9-2.6c-0.9-0.5-1.9-0.9-3-1.3c0.2,0.6,0.4,1.3,0.6,2C28.1,18.5,28.3,19.2,28.5,19.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Technology
};
